import { ConditionType, ConsentRow as SharedConsentRow } from '@/features/dryad';
import { ConditionTypeSelect } from './condition-type-select';

type ConsentRowProps = {
  /** The leaf node's id, supplied by the group to every registered view. */
  id: string;
};

/** The people surface's binding of the shared consent row. */
export function ConsentRow({ id }: ConsentRowProps) {
  return (
    <SharedConsentRow
      id={id}
      conditionType={ConditionType.Consent}
      typeSelect={<ConditionTypeSelect nodeId={id} currentType={ConditionType.Consent} />}
    />
  );
}
